export default __webpack_public_path__ + "static/media/c74d23908dc9d1e1731bf13e9df4164b.png";